import { config } from '@/config/environment';
import { Global } from '@emotion/react';
import styled from '@emotion/styled';
import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useExploreQuery } from '../hooks/use-explore-query';
import ExploreMapMarker from './explore-map-markers';

const StyledMapWrapper = styled.div`
  height: 64vh;
  padding: 15px;
  background-color: #ffffff;
  position: sticky;
  top: 100px;
  margin-bottom: 40px;
  border-radius: 70px;
`;
const NewExploreInPersonMap = () => {
  const { data, loading } = useExploreQuery();
  const mapComponentRef = useRef<GoogleMap>();
  const mapRef = useRef<google.maps.Map>();
  const [init, setInit] = useState([false, false]);
  const fullyInit = init[0] && init[1];
  const url = useMemo(() => {
    return window.location.href;
  }, []);

  useEffect(() => {
    if (mapRef.current && fullyInit && !loading) {
      const bounds = new window.google.maps.LatLngBounds();
      data?.experiences?.edges.forEach(experience => {
        if (experience?.node?.approximateLocation) {
          bounds.extend(
            new window.google.maps.LatLng(
              experience?.node?.approximateLocation?.coordinates[1],
              experience?.node?.approximateLocation?.coordinates[0],
            ),
          );
        }
      });
      google.maps.event.addListenerOnce(mapRef.current, 'idle', function () {
        mapRef.current?.setCenter(bounds.getCenter());
        mapRef.current?.fitBounds(bounds);
      });
    }
  }, [data?.experiences?.edges, fullyInit, loading, url]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: config.googleApiKey!,
  });
  if (isLoaded) {
    const center = new google.maps.LatLng(49.2827, -123.1207);
    return (
      <StyledMapWrapper>
        <Global
          styles={{
            '.gm-style .gm-style-iw-c': {
              width: '301px',
              height: '98px',
              padding: '0px',
            },
            '.gm-style-iw-chr': {
              height: '24px',
              borderRadius: '14px',
            },
            'html, body': {
              height: '100%',
              overflow: 'auto',
              scrollBehavior: 'smooth',
            },
          }}
        />
        <GoogleMap
          zoom={15}
          center={center}
          mapContainerStyle={{ width: '100%', height: '100%', borderRadius: '54px' }} //boundingbox??
          ref={props => {
            mapComponentRef.current = props!;
            if (!init[0]) {
              setInit([true, init[1]]);
            }
          }}
          onLoad={map => {
            mapRef.current = map;
            if (!init[1]) {
              setInit([init[0], true]);
            }
          }}
        >
          {data?.experiences?.edges?.map(experience => {
            return <ExploreMapMarker experience={experience} key={experience?.node?.id} />;
          }) ?? []}
        </GoogleMap>
      </StyledMapWrapper>
    );
  }
  return null;
};
export default NewExploreInPersonMap;
